// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddTaskDropzoneController from "./add_task_dropzone_controller"
application.register("add-task-dropzone", AddTaskDropzoneController)

import AssignmentController from "./assignment_controller"
application.register("assignment", AssignmentController)

import BulkArchiveController from "./bulk_archive_controller"
application.register("bulk-archive", BulkArchiveController)

import AvatarController from "./avatar_controller"
application.register("avatar", AvatarController)

import ChatworkStepsController from "./chatwork_steps_controller"
application.register("chatwork-steps", ChatworkStepsController)

import CustomDropdownController from "./custom_dropdown_controller"
application.register("custom-dropdown", CustomDropdownController)

import AssigneeSelectController from "./assignee_select_controller"
application.register("assignee-select", AssigneeSelectController)

import DocsMenuController from "./docs_menu_controller"
application.register("docs-menu", DocsMenuController)

import DraftClearController from "./draft_clear_controller"
application.register("draft-clear", DraftClearController)

import DraftDetectorController from "./draft_detector_controller"
application.register("draft-detector", DraftDetectorController)

import EmailRegistrationController from "./email_registration_controller"
application.register("email-registration", EmailRegistrationController)

import ExpandableCardController from "./expandable_card_controller"
application.register("expandable-card", ExpandableCardController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FloatMenuController from "./float_menu_controller"
application.register("float-menu", FloatMenuController)

import FormController from "./form_controller"
application.register("form", FormController)

import FormTextController from "./form_text_controller"
application.register("form-text", FormTextController)

import NarrowListController from "./narrow_list_controller"
application.register("narrow-list", NarrowListController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NotificationUpdaterController from "./notification_updater_controller"
application.register("notification-updater", NotificationUpdaterController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import PwaInstallController from "./pwa_install_controller"
application.register("pwa-install", PwaInstallController)

import PositionReorderController from "./position_reorder_controller"
application.register("position-reorder", PositionReorderController)

import ReactionPickerController from "./reaction_picker_controller"
application.register("reaction-picker", ReactionPickerController)

import RecaptchaController from "./recaptcha_controller"
application.register("recaptcha", RecaptchaController)

import ProgressBoardController from "./progress_board_controller"
application.register("progress-board", ProgressBoardController)

import ProgressController from "./progress_controller"
application.register("progress", ProgressController)

import RelatedTaskPaneController from "./task_browse_pane_controller"
application.register("task-browse-pane", RelatedTaskPaneController)

import RemoteModalController from "./remote_modal_controller"
application.register("remote-modal", RemoteModalController)

import SidePageController from "./side_page_controller"
application.register("side-page", SidePageController)

import SlackFloatController from "./slack_float_controller"
application.register("slack-float", SlackFloatController)

import SwiperBoardController from "./swiper_board_controller"
application.register("swiper-board", SwiperBoardController)

import TaskController from "./task_controller"
application.register("task", TaskController)

import ToastUiController from "./toast_ui_controller"
application.register("toast-ui", ToastUiController)

import StopPropagationController from "./stop_propagation_controller"
application.register("stop-propagation", StopPropagationController)

import TodoAssigneeToggleController from "./todo_assignee_toggle_controller"
application.register("todo-assignee-toggle", TodoAssigneeToggleController)

import TotalPointController from "./total_point_controller"
application.register("total-point", TotalPointController)

import TutorialController from "./tutorial_controller"
application.register("tutorial", TutorialController)

import UrlShareController from "./url_share_controller"
application.register("url-share", UrlShareController)
